export default {
    PAYMENT: 'PAYMENT',
    PAYMENT_START: 'PAYMENT_START',
    PAYMENT_FINISHED: 'PAYMENT_FINISHED',
    PAYMENT_ERROR: 'PAYMENT_ERROR',
};
